<div>
  @for (dto of filteredDayDtos(); track dto.date) {
    <div class="work-card margin-bottom-24">
      @for (teamDto of dto.teams; track teamDto.teamId) {
        <div class="flex flex-column gap-16">
          @if (dayjs(dto.date).isSame(dayjs(), 'day')) {
            <div class="flex flex-row vertical-center gap-4">
              <work-ui-icon name="calendar_month" />
              {{ 'HEUTE' | translate }}: {{ 'TEAM' | translate }} {{ teamDto.team }}
            </div>
          } @else {
            <div class="flex flex-row vertical-center gap-4">
              <work-ui-icon name="calendar_month" />
              {{ dto.date | formatDate:'dddd, DD.MM.YYYY' }}: {{ 'TEAM' | translate }} {{ teamDto.team }}
            </div>
          }
          @for (userPartial of workMontageplanUsersTeamPartial(); track userPartial.userId) {
            @let timerecord = userPartial.timerecords[dto.date];
            @if (timerecord) {
              <div class="flex flex-row gap-8 vertical-center" (click)="openUserDetails.emit(userPartial.userId)">
                <work-ui-avatar [initials]="!!userPartial.user.userImage ? '' : (userPartial.user | getInitials)"
                                [workUiTooltip]="userPartial.user.firstName + ' ' + userPartial.user.lastName"
                                [status]="timerecord.timerecordtypeName | getAvatarStatusByTimerecordtype"
                                [imgSrc]="userPartial.user.userImage ? (userPartial.user.userImage.fileSrcThumbnail | prependServerToFileSrc) : null" />
                <div class="flex flex-column">
                  <h3>{{ userPartial.user.firstName + ' ' + userPartial.user.lastName }}</h3>
                  @if (timerecord.isTeamLead) {
                    <p>{{ 'TEAMLEITUNG' | translate }}</p>
                  }
                  @if (timerecord.hasBirthday) {
                    <p>{{ 'GEBURTSTAG' | translate }}!</p>
                  }
                  @let displayedType = (timerecord.timerecordtypeName === WorkTimerecordtypeNameEnum.Frei && (teamDto.blocks.length || teamDto.tasks.length))
                    ? WorkTimerecordtypeNameEnum.Arbeit
                    : timerecord.timerecordtypeName;
                  <div class="flex flex-row vertical-center gap-4">
                    <work-ui-icon [name]="displayedType | getTimerecordtypeIconName" />
                    <p>{{ displayedType }}</p>
                  </div>
                </div>
              </div>
            }
          }
          @for (block of teamDto.blocks; track block.id) {
            <div class="work-card work-card--is-clickable padding-narrow"
                 (click)="block.projectId ? openProjectDetails.emit(block.projectId) : undefined">
              <p>{{ block.taskName }}</p>
              <h3>{{ block.projectName }}</h3>
              <p>{{ 'KUNDE' | translate }}: {{ block.customerName }}</p>
              <p>
                <span>{{ 'OBJEKTADRESSE' | translate }}: </span>
                <span>{{ block.projectStreet }}, {{ block.projectZipCode }} {{ block.projectCity }}</span>
              </p>
            </div>
          } @empty {
            <p>{{ 'KEINE_PROJEKTE_EINGEPLANT' | translate }}</p>
          }
          @if (teamDto.tasks.length) {
            <hr>
          }
          @for (task of teamDto.tasks; track task.id) {
            <div class="work-card work-card--is-clickable padding-narrow"
                 (click)="task.projectId ? openProjectDetails.emit(task.projectId) : undefined">
              @if (task.status) {
                <p>{{ task.status }}</p>
              }
              <h3>{{ task.name }}</h3>
              @let taskStartTime = task.start | formatDate:'HH:mm';
              @if (taskStartTime !== '00:00') {
                <p>{{ 'X_UHR' | translate: { time: taskStartTime } }}</p>
              }
              @if (task.createdByUser) {
                <p>
                  <span>{{ 'ERSTELLT_VON' | translate }}: </span>
                  {{ task.createdByUser.firstName }} {{ task.createdByUser.lastName }}
                </p>
              }
            </div>
          }
        </div>
      } @empty {
        <div class="flex flex-row vertical-center gap-4">
          <work-ui-icon name="calendar_month" />
          {{ dto.date | formatDate:'dddd, DD.MM.YYYY' }}: {{ 'TEAM_KEIN' | translate }} {{ 'ZUGEWIESEN' | translate | lowercase }}
        </div>
      }
    </div>
  } @empty {
    <p>{{ 'EINTRAEGE_KEINE' | translate }}</p>
  }
</div>
